import { createSlice } from "@reduxjs/toolkit";
import { resetStore } from "app/actions";
import { RootState } from "app/store";
import { panicMode } from "app/thunks/modesAPI";

export enum MODES {
  PANIC_MODE = "PANIC_MODE",
  RESET_MODE = "RESET_MODE",
}

export interface State {
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  error: any;
}

const initialState: State = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  error: undefined,
};

export const modesSlice = createSlice({
  name: "modes",
  initialState,
  reducers: {
    resetFlags: (state) => {
      state.isSuccess = false;
      state.isLoading = false;
      state.isError = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(resetStore, () => initialState)
      .addCase(panicMode.pending, (state) => {
        state.isSuccess = false;
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(panicMode.rejected, (state, action) => {
        state.isSuccess = false;
        state.isLoading = false;
        state.isError = true;
        state.error = action.payload;
      })
      .addCase(panicMode.fulfilled, (state) => {
        state.isSuccess = true;
        state.isLoading = false;
        state.isError = false;
      });
  },
});

export const { resetFlags } = modesSlice.actions;

// ------ Selectors ------

export const getModesActionState = (state: RootState) => ({
  isLoading: state.modes.isLoading,
  isSuccess: state.modes.isSuccess,
  isError: state.modes.isError,
  error: state.modes.error,
});

export default modesSlice.reducer;
